module.exports={
  "+CJ9tU": "Dropoffs / deliveries",
  "+OefFe": "We will only use your phone number for booking updates.",
  "+QNm85": "Parking",
  "+gRnOa": "required",
  "+ldK7U": "Pink photoshoot ideas",
  "/+axU7": "Training",
  "/4tOwT": "Skip",
  "/6gLBc": "Verification code",
  "/TDGTy": "List Your Space",
  "/VnDMl": "Other",
  "/fz4Pq": "If you do not confirm your availability, any available times on the dates listed above will be blocked on your calendar and cannot be booked by anyone.",
  "/tF5Iw": "Furniture",
  "0//omL": "Colombes",
  "078WAr": "See all",
  "08REwr": "Fort Erie",
  "0yGZCO": "Party add-ons",
  "1++vpR": "Vaughan",
  "11oARw": "Pool",
  "13+NSP": "Partially Booked",
  "14DitK": "Basketball Court",
  "1O6LIm": "Uploading {num} Assets",
  "25WwxF": "Don't have an account?",
  "2GoZaO": "Cyclorama",
  "2UxfXJ": "Production equipment",
  "2lJl19": "House",
  "39AHJm": "Sign Up",
  "3Dw73J": "Boards",
  "3NVyN7": "Please enter your first name",
  "3ZwCrL": "Drag and Drop assets here",
  "4CrCbD": "Community",
  "4DiBkU": "Didn't get an email? It can take a few minutes, but also check your Spam and Promotions folders.",
  "4dDCHm": "Glebe",
  "4vfPVv": "Please confirm your availability for upcoming Saturdays",
  "4wpUNc": "Or",
  "4zwrmb": "We noticed your calendar might not be up to date.",
  "55eCJh": "Add a profile photo",
  "5Jcaq4": "NEW",
  "5Nf1Fj": "Office supplies",
  "5lIxBt": "San Diego",
  "5lP56d": "Add-ons",
  "5q3qC0": "Download",
  "5sg7KC": "Password",
  "65HtZt": "Baby shower ideas",
  "691UH3": "Party ideas",
  "6A9eHt": "Paddington",
  "7JlauX": "Explore",
  "7TI3X5": "Peerspace's Services Agreement",
  "7frda3": "Verify phone number",
  "7gqDGc": "{num} failed",
  "8HJxXG": "Sign up",
  "8p+bZ6": "Complete profile",
  "8u+TwD": "Your password needs to be at least 8 characters long and include a number",
  "8ukGRF": "Surrey",
  "8vtzS7": "Cabin",
  "99BbJD": "Fitzroy",
  "99oTOg": "{num} uploaded",
  "9H3bhD": "Forgot password",
  "9YazHG": "Company",
  "9aD6GO": "Drop files to upload",
  "9z1SUK": "Your privacy choices",
  "AXu+2m": "Baby Shower",
  "AeLn0q": "Error loading image",
  "AetNAD": "Browse",
  "AjhJXS": "My Files",
  "AyGauy": "Login",
  "BFV+Wa": "Standard message and data rates may apply.",
  "BmecBA": "Continue with Apple",
  "BtHRXe": "resend the code.",
  "BzEqxq": "Boudoir photoshoot ideas",
  "CI5DIr": "North Sydney",
  "CkbYXz": "Image dimensions ({width}X{height}) are smaller than the minimum required: ({minWidth}X{minHeight})",
  "Cmxyr0": "Table settings",
  "Coy6SH": "Calendar",
  "D+pBML": "Issy-les-Moulineaux",
  "D2Gq0A": "Piano",
  "DAzdLz": "Essex",
  "DXCo0j": "Image dimensions ({width}X{height}) are bigger than the maximum allowed: ({maxWidth}X{maxHeight})",
  "Dg2c3+": "Sydney",
  "DoLnld": "South Melbourne",
  "E2a+OA": "Mansion",
  "EEYbEu": "Spring photoshoot ideas",
  "EHm76q": "Outdoor photoshoot ideas",
  "EmpHyB": "Facebook",
  "Eww+Ll": "Los Angeles",
  "F+Yfhq": "{cost}/hr",
  "FJ6r9E": "Continue with Google",
  "FPGwAt": "Company name",
  "FPcbu0": "Please enter a valid phone number",
  "G/yZLu": "Remove",
  "G55dd+": "Peerspace's processing fee and applicable taxes will be calculated in checkout.",
  "GZo7vg": "See less",
  "GhhgBS": "Couples photoshoot ideas",
  "GhzUla": "Set your preferred language and region",
  "GyVL+y": "Drag and Drop an asset here",
  "H0JBH6": "Log Out",
  "Hdh+IN": "Report Vulnerability",
  "HqRNN8": "Support",
  "HsQ3BK": "Job title",
  "HtSDyc": "Help Center",
  "I+s9q3": "Extra space",
  "I8S8o5": "Houston",
  "ILEVq7": "Commercial Kitchen",
  "ILOlvJ": "There are running uploads. Click OK to abort.",
  "Idg+3/": "Wedding",
  "IeZnKQ": "Retry failed",
  "IwPN/4": "Vitry-sur-Seine",
  "J1heb1": "Upload Queue",
  "JEsxDw": "Uploading...",
  "JVuVOx": "Chicago",
  "JXdbo8": "Done",
  "JhlNhU": "Please upload a profile photo",
  "K+ooxo": "Grill",
  "KN7zKn": "Error",
  "Kly88A": "Peerspace will send you deals, inspiration, and marketing emails. You can opt out at any time from your account settings.",
  "KnZeCK": "Ivry-sur-Seine",
  "KrJHKp": "Drop a file to upload",
  "LM5YIv": "Brighton and Hove",
  "LhciBG": "Brookvale",
  "LwdDVa": "Uploaded",
  "MA2oNV": "Summer photoshoot ideas",
  "MBb3Nk": "Dismiss for now",
  "MCjvO5": "Food and drinks",
  "MXxQt0": "Birthday Party",
  "Mxb8pC": "Green Screen",
  "MylGwB": "Photoshoot ideas",
  "N+FI5p": "Arcueil",
  "N2IrpM": "Confirm",
  "NFExFT": "Browse Spaces",
  "NZ3ZWg": "Fully Booked",
  "NcRLxd": "West Midlands",
  "Ntjkqd": "or",
  "Nw2RAN": "Austin",
  "OAJbO9": "A/V equipment",
  "OKCmDO": "Was in a Peerspace location",
  "OTN0yk": "Apple",
  "Oz0em5": "Upload a profile photo",
  "PU8XIi": "Workshop",
  "PgJGHT": "Available",
  "QWalHQ": "Edinburgh",
  "QtFGiO": "Host",
  "R2a7M8": "Your phone number was unable to be verified",
  "RNRpjD": "Crop",
  "S40Ltd": "Skip, I'll do this later",
  "SENRqu": "Help",
  "SEXlnF": "Confirm these dates",
  "SHryPO": "Bar",
  "ShJCpJ": "Friend or family",
  "SqASnd": "New York",
  "TCluAN": "Berlin",
  "TITyTR": "San Francisco",
  "Tv1r3X": "Montreuil",
  "U+wBOG": "Dallas",
  "UBPEs+": "Verify my number",
  "URiaxp": "Malakoff",
  "UfMD1l": "Paris",
  "UmEsZF": "Activities",
  "VCMKbt": "Inbox",
  "VvI8Km": "Please enter a valid verification code",
  "WaZD9I": "Toronto",
  "WfJuoP": "Max {max}",
  "WrC3fL": "Maximum number of files exceeded",
  "XJ6R6h": "Nottingham",
  "XNTGJ1": "For better security and seamless communication with guests, phone number verification will soon be required.",
  "XZhjtd": "Movie Theater",
  "Xkyqpe": "Barcelona",
  "Y+a2oj": "Peerspace",
  "Y4fxUa": "Black and white photoshoot ideas",
  "YV+jwf": "Lounge",
  "YekgnB": "London",
  "ZD48TW": "Resend code",
  "ZEEVQX": "Social media",
  "ZoQKy9": "Saint-Maur-des-Fossés",
  "ZxG5bx": "Atlanta",
  "ZxX/VV": "Bridal Shower",
  "a5msuh": "Yes",
  "a6n0ds": "Dinner",
  "aMktaB": "North Vancouver",
  "aMwxYb": "Countries",
  "abR4YB": "By clicking Sign up, you agree to {servicesAgreement} and {privacyPolicy}.",
  "acrOoz": "Continue",
  "akf4Dz": "Closing will cancel all uploads, Are you sure?",
  "auth_messages.suspended_account": "It appears that your account is no longer active on Peerspace. If you believe this is a mistake, or if you need further assistance, please {link} and select \"I want to appeal my account status\".",
  "auth_messages.suspended_account.contact_support": "contact our support team",
  "b4N8ds": "Bathtub",
  "bRCnfK": "Saint-Ouen",
  "booking_request.booking_details.attendees": "How many people will attend?",
  "button.submit": "Submit",
  "c/KktL": "Resources",
  "cGO4U0": "File size ({size}) exceeds maximum allowed ({allowed})",
  "cXBJ7U": "Privacy",
  "calendar_availability.available": "Available",
  "calendar_availability.confirm_dates": "Confirm these dates",
  "calendar_availability.fully_booked": "Fully Booked",
  "calendar_availability.mini_modal.dismiss": "Dismiss for now",
  "calendar_availability.mini_modal.title": "Please confirm that your calendar is up-to-date for the next four Saturdays.",
  "calendar_availability.partially_booked": "Partially Booked",
  "calendar_availability.subtitle": "Did you know Saturdays are the most booked days for events? Please take a moment to confirm your availability or update your calendar.",
  "calendar_availability.title": "Please confirm your upcoming weekend availability",
  "calendar_availability.view_edit_cal": "View or edit calendar",
  "currUk": "Continue with Facebook",
  "cwF8M8": "Check this box to opt out of marketing emails.",
  "dUxyza": "Reviews",
  "dd9FfL": "Retreat",
  "dlq/cS": "By clicking Continue, you agree to {servicesAgreement} and {privacyPolicy}.",
  "e38GOF": "Amenities",
  "eYoQAs": "Leicester",
  "ef99Fb": "NA",
  "elements_search_module.with_activity_dropdown_hoc.what_planning_placeholder": "What are you planning?",
  "elements_search_module.with_location_dropdown_hoc.enter_city": "Enter a city, zip, or address",
  "elements_search_module.with_location_dropdown_hoc.where": "Where?",
  "eoCVdq": "Peerspace contacted me",
  "eqJt7H": "California Privacy",
  "eqyDoA": "List your space",
  "f3Cn8g": "Extend a day",
  "fAPZhr": "fees",
  "fEugQE": "Fireplace",
  "fFuV7a": "File is too small",
  "fIy1Vf": "Trust and Safety",
  "fQg62f": "Asnières-sur-Seine",
  "form_component.form_component.clear": "Clear",
  "forms.space_type_form.no_options": "No options",
  "fwUefo": "St Kilda",
  "g5pX+a": "About",
  "gZlFBP": "Okay",
  "gaL5xo": "View or edit calendar",
  "ghuN9R": "Philadelphia",
  "hCxD4H": "Space Types",
  "hQ0JgO": "Neuilly-sur-Seine",
  "hZBGIJ": "Please confirm that your calendar is up-to-date for the next four Saturdays.",
  "hi+DfN": "Drag corner to resize",
  "hn3/Ua": "Listings",
  "host.profile.basic_information_phone_number_modal_placedholder": "Phone number",
  "host.profile.basic_information_verify_number_modal_cta": "Verify",
  "host.profile.basic_information_verify_number_modal_header": "Verify phone number",
  "host.profile.basic_information_verify_number_modal_placeholder": "Verification code",
  "host.profile.basic_information_verify_number_modal_resend_link": "resend the code",
  "host.profile.basic_information_verify_number_modal_subheader": "Enter the 4-digit code we sent to {phone_number} below. If you didn’t get it, {resend}.",
  "hosting.invoice_page.credit_notes_text": "Credit notes",
  "hosting.invoice_page.date_posted_text": "Date posted",
  "hosting.invoice_page.description_text": "Description",
  "hosting.invoice_page.excluding_text": "excluding",
  "hosting.invoice_page.faq": "FAQ",
  "hosting.invoice_page.guest_name": "{name}'s space on {date}",
  "hosting.invoice_page.invoice": "Invoice",
  "hosting.invoice_page.invoice_for_text": "Invoice for",
  "hosting.invoice_page.invoice_from_text": "Invoice from",
  "hosting.invoice_page.last_updated_text": "Last Updated",
  "hosting.invoice_page.no_credits_copy": "You have no credit notes this month",
  "hosting.invoice_page.no_invoices_copy": "You have no invoices this month",
  "hosting.invoice_page.peerspace_services_agreement": "Peerspace Services Agreement",
  "hosting.invoice_page.ps_service_fee_text": "Peerspace service fee",
  "hosting.invoice_page.registration_id_text": "Registration ID",
  "hosting.invoice_page.reverse_charge_text": "reverse charge",
  "hosting.invoice_page.total_amount": "Total amount",
  "hosting.invoice_page.vat_information": "Peerspace charges a Service Fee including applicable VAT/GST to both the Host and the Guest for the use of the Peerspace online platform. The costs set by the Host (Booking Price and Cleaning Fee or Host Add-Ons Fee, if applicable) are paid by the Guest through the Peerspace online platform and these costs are also received by the Host through the Peerspace online platform, all of which is facilitated by a 3rd party payment service provider . The Host is responsible for supplying a valid VAT/GST invoice for these costs (excluding the Guest service fee) if requested by the Guest. Please note if you want a VAT/GST invoice for the full booking, including Peerspace’s Service Fee for using the online platform, you will need to request an invoice from both the Host and Peerspace, and these two invoices will include the total amount of VAT/GST applicable to your booking. For more information about tax handling, please see our {faqLink} and the {serviceAgreementLink}",
  "hosting.invoice_page.vat_rate": "Vat rate",
  "hosting.invoice_page.vat_reverse_charge_copy": "A reverse charge was applied to the VAT on any booking where your VAT was stored in your profile at the time the booking was accepted. You were not charged VAT on these bookings.",
  "hosting.on_submit_attendee_price_form.error_message": "Something went wrong, please try again.",
  "hosting.profile.verification_limit_error": "Something went wrong. Please contact our {link}",
  "hsYvDX": "Uploading",
  "i1GA35": "Seattle",
  "i7dlZh": "Boulogne-Billancourt",
  "iTnblA": "Please confirm your upcoming weekend availability",
  "iYc3Ld": "Payments",
  "iiYrag": "Please enter your password",
  "inbox.host_survey_modal.peerspace_other_calendar_cta": "Next",
  "itPgxd": "Profile",
  "jTJDNE": "Video Shoot",
  "jdJhOL": "Phone number",
  "jm/spn": "Reset",
  "jnKBW0": "Abort all",
  "jpL4NC": "Warehouse",
  "k5+UAZ": "Calgary",
  "kYlEKW": "{cost}/person",
  "khxeQh": "Glasgow",
  "l5Edgj": "Edmonton",
  "l9kDZq": "Show completed",
  "listing.collapsing_container.show_all": "Show all",
  "listing.collapsing_container.show_less": "Show less",
  "listing.event_faq.section.activities_available": "Activities available during booking",
  "listing.event_faq.section.activities_not_permitted": "Events this space does not wish to host",
  "listing.listing_card.view_details_overlay_text": "View details",
  "listing.location_dropdown.where_message": "Where?",
  "listing.msg_host_modal_success.match": "Match: Location, guest count, activity +",
  "listing.production_faq.accordion_image": "icon",
  "listing.production_faq.hide": "Hide",
  "listing.production_faq.read_more": "Read more",
  "listings.disclaimer.stripe_connected": "Stripe Connected Account Agreement",
  "lzgH40": "Google",
  "mYJ6iK": "Staffing and services",
  "nF/Vxl": "Birthday photoshoot ideas",
  "nabCJU": "Vancouver",
  "navbar_browse_paths.activities": "Activities",
  "navbar_browse_paths.activities.baby_shower": "Baby Shower",
  "navbar_browse_paths.activities.birthday_party": "Birthday Party",
  "navbar_browse_paths.activities.bridal_shower": "Bridal Shower",
  "navbar_browse_paths.activities.dinner": "Dinner",
  "navbar_browse_paths.activities.film_shoot": "Film Shoot",
  "navbar_browse_paths.activities.meeting": "Meeting",
  "navbar_browse_paths.activities.party": "Party",
  "navbar_browse_paths.activities.photo_shoot": "Photo Shoot",
  "navbar_browse_paths.activities.retreat": "Retreat",
  "navbar_browse_paths.activities.see_all": "See all",
  "navbar_browse_paths.activities.training": "Training",
  "navbar_browse_paths.activities.video_shoot": "Video Shoot",
  "navbar_browse_paths.activities.wedding": "Wedding",
  "navbar_browse_paths.activities.wedding_reception": "Wedding Reception",
  "navbar_browse_paths.activities.workshop": "Workshop",
  "navbar_browse_paths.amenities": "Amenities",
  "navbar_browse_paths.amenities.bathtub": "Bathtub",
  "navbar_browse_paths.amenities.cyclorama": "Cyclorama",
  "navbar_browse_paths.amenities.deck": "Deck",
  "navbar_browse_paths.amenities.fire_pit": "Fire Pit",
  "navbar_browse_paths.amenities.fireplace": "Fireplace",
  "navbar_browse_paths.amenities.green_screen": "Green Screen",
  "navbar_browse_paths.amenities.grill": "Grill",
  "navbar_browse_paths.amenities.kitchen": "Kitchen",
  "navbar_browse_paths.amenities.lounge": "Lounge",
  "navbar_browse_paths.amenities.patio": "Patio",
  "navbar_browse_paths.amenities.piano": "Piano",
  "navbar_browse_paths.amenities.pool": "Pool",
  "navbar_browse_paths.ideas": "Ideas",
  "navbar_browse_paths.ideas.baby_shower_ideas": "Baby shower ideas",
  "navbar_browse_paths.ideas.birthday_photoshoot_ideas": "Birthday photoshoot ideas",
  "navbar_browse_paths.ideas.black_and_white_photoshoot_ideas": "Black and white photoshoot ideas",
  "navbar_browse_paths.ideas.boudoir_photoshoot_ideas": "Boudoir photoshoot ideas",
  "navbar_browse_paths.ideas.bridal_shower_ideas": "Bridal shower ideas",
  "navbar_browse_paths.ideas.couples_photoshoot_ideas": "Couples photoshoot ideas",
  "navbar_browse_paths.ideas.outdoor_photoshoot_ideas": "Outdoor photoshoot ideas",
  "navbar_browse_paths.ideas.party_ideas": "Party ideas",
  "navbar_browse_paths.ideas.photoshoot_ideas": "Photoshoot ideas",
  "navbar_browse_paths.ideas.pink_photoshoot_ideas": "Pink photoshoot ideas",
  "navbar_browse_paths.ideas.see_all": "See all",
  "navbar_browse_paths.ideas.spring_photoshoot_ideas": "Spring photoshoot ideas",
  "navbar_browse_paths.ideas.summer_photoshoot_ideas": "Summer photoshoot ideas",
  "navbar_browse_paths.locations": "Locations",
  "navbar_browse_paths.locations.arcueil": "Arcueil",
  "navbar_browse_paths.locations.asnières_sur_seine": "Asnières sur Seine",
  "navbar_browse_paths.locations.atlanta": "Atlanta",
  "navbar_browse_paths.locations.austin": "Austin",
  "navbar_browse_paths.locations.bagnolet": "Bagnolet",
  "navbar_browse_paths.locations.barcelona": "Barcelona",
  "navbar_browse_paths.locations.berlin": "Berlin",
  "navbar_browse_paths.locations.boulogne_billancourt": "Boulogne-Billancourt",
  "navbar_browse_paths.locations.brighton_and_hove": "Brighton and Hove",
  "navbar_browse_paths.locations.bristol": "Bristol",
  "navbar_browse_paths.locations.brookvale": "Brookvale",
  "navbar_browse_paths.locations.calgary": "Calgary",
  "navbar_browse_paths.locations.chicago": "Chicago",
  "navbar_browse_paths.locations.colombes": "Colombes",
  "navbar_browse_paths.locations.dallas": "Dallas",
  "navbar_browse_paths.locations.edinburgh": "Edinburgh",
  "navbar_browse_paths.locations.edmonton": "Edmonton",
  "navbar_browse_paths.locations.essex": "Essex",
  "navbar_browse_paths.locations.fitzroy": "Fitzroy",
  "navbar_browse_paths.locations.fort_erie": "Fort Erie",
  "navbar_browse_paths.locations.glasgow": "Glasgow",
  "navbar_browse_paths.locations.glebe": "Glebe",
  "navbar_browse_paths.locations.houston": "Houston",
  "navbar_browse_paths.locations.issy_les_moulineaux": "Issy Les Moulineaux",
  "navbar_browse_paths.locations.ivry_sur_seine": "Ivry-sur-Seine",
  "navbar_browse_paths.locations.leicester": "Leicester",
  "navbar_browse_paths.locations.london": "London",
  "navbar_browse_paths.locations.los_angeles": "Los Angeles",
  "navbar_browse_paths.locations.malakoff": "Malakoff",
  "navbar_browse_paths.locations.manchester": "Manchester",
  "navbar_browse_paths.locations.melbourne": "Melbourne",
  "navbar_browse_paths.locations.mississauga": "Mississauga",
  "navbar_browse_paths.locations.montreuil": "Montreuil",
  "navbar_browse_paths.locations.neuilly_sur_seine": "Neuilly-Sur-Seine",
  "navbar_browse_paths.locations.new_york": "New York",
  "navbar_browse_paths.locations.newtown": "Newtown",
  "navbar_browse_paths.locations.north_sydney": "North Sydney",
  "navbar_browse_paths.locations.north_vancouver": "North Vancouver",
  "navbar_browse_paths.locations.nottingham": "Nottingham",
  "navbar_browse_paths.locations.paddington": "Paddington",
  "navbar_browse_paths.locations.pantin": "Pantin",
  "navbar_browse_paths.locations.paris": "Paris",
  "navbar_browse_paths.locations.philadelphia": "Philadelphia",
  "navbar_browse_paths.locations.richmond": "Richmond",
  "navbar_browse_paths.locations.richmond_hill": "Richmond Hill",
  "navbar_browse_paths.locations.saint_maur_des_fossés": "Saint-Maur-des-Fossés",
  "navbar_browse_paths.locations.saint_ouen": "Saint Ouen",
  "navbar_browse_paths.locations.san_diego": "San Diego",
  "navbar_browse_paths.locations.san_francisco": "San Francisco",
  "navbar_browse_paths.locations.seattle": "Seattle",
  "navbar_browse_paths.locations.see_all": "See all",
  "navbar_browse_paths.locations.south_melbourne": "South Melbourne",
  "navbar_browse_paths.locations.st_kilda": "St Kilda",
  "navbar_browse_paths.locations.surrey": "Surrey",
  "navbar_browse_paths.locations.sydney": "Sydney",
  "navbar_browse_paths.locations.toronto": "Toronto",
  "navbar_browse_paths.locations.vancouver": "Vancouver",
  "navbar_browse_paths.locations.vaughan": "Vaughan",
  "navbar_browse_paths.locations.vitry_sur_seine": "Vitry-sur-Seine",
  "navbar_browse_paths.locations.washington_dc": "Washington D.C.",
  "navbar_browse_paths.locations.west_midlands": "West Midlands",
  "navbar_browse_paths.space_types": "Space Types",
  "navbar_browse_paths.space_types.bar": "Bar",
  "navbar_browse_paths.space_types.barn": "Barn",
  "navbar_browse_paths.space_types.basketball-court": "Basketball Court",
  "navbar_browse_paths.space_types.cabin": "Cabin",
  "navbar_browse_paths.space_types.castle": "Castle",
  "navbar_browse_paths.space_types.commercial_kitchen": "Commercial Kitchen",
  "navbar_browse_paths.space_types.community_center": "Community Center",
  "navbar_browse_paths.space_types.garage": "Garage",
  "navbar_browse_paths.space_types.house": "House",
  "navbar_browse_paths.space_types.mansion": "Mansion",
  "navbar_browse_paths.space_types.movie_theater": "Movie Theater",
  "navbar_browse_paths.space_types.warehouse": "Warehouse",
  "neM2P5": "We require phone number verification to protect your account. Please try again later.",
  "o/gK53": "Deck",
  "o3UAuK": "View Calendar",
  "odXlk8": "Log in",
  "oehpS9": "Richmond Hill",
  "pONqz8": "First name",
  "pOryCk": "Barn",
  "pWWzFs": "Never miss a booking update",
  "ppfkRA": "I don't want to receive marketing emails from Peerspace.",
  "prBAWB": "Please enter a valid email",
  "price_summary.attendee_count": "For {attendeeCount} guests",
  "price_summary.available_in_checkout_copy": "available in checkout",
  "price_summary.before_taxes_label": "before taxes",
  "price_summary.cleaning_fee": "Cleaning fee",
  "price_summary.discount_hourly": "Hourly discount (8+ hrs)",
  "price_summary.discount_total_price": "8+ hour discount ({discount}%)",
  "price_summary.hour_label": "hour",
  "price_summary.hourly_price": "Hourly price",
  "price_summary.hourly_price_discount_label": "8+ hour discount",
  "price_summary.hourly_price_discount_modification": "8+ hour discount ({pctDiscount}%)",
  "price_summary.hourly_price_tier_modification": "Hourly price for {tier} guests",
  "price_summary.hourly_price_tier_modification_default": "For {tier} guests",
  "price_summary.hours_label": "{numberOfHours, plural, one {# hour} other {# hours}}",
  "price_summary.pay_now_pay_later": "Pay part now, part later available in checkout",
  "price_summary.pay_part_now_copy": "Pay part now, part later",
  "price_summary.price_details": "Price details",
  "price_summary.processing_fee_caption": "Peerspace’s processing fee and applicable taxes will be calculated in checkout.",
  "price_summary.processing_fee_label": "Processing fee",
  "price_summary.total_before_taxes": "Est. total before taxes",
  "price_summary.total_label": "Total",
  "profile.basic_add_update_your_phone_header": "Never miss a booking update",
  "profile.basic_data_rates_message": "Standard message and data rates may apply.",
  "q+dC7x": "What's the best email for you?",
  "q5Xl0M": "Verify",
  "qGANn7": "Washington DC",
  "qGb+T3": "Locations",
  "qMchKN": "Party",
  "qOLogg": "Social",
  "qSNkac": "Pantin",
  "qZbedW": "Fees",
  "rDPYm3": "Ambassador Program",
  "rPaQ+c": "{cost} flat fee",
  "rWfLe+": "Uploading Assets",
  "rXzOE5": "Bristol",
  "s/qo4z": "Please enter your last name",
  "sCIAEs": "Patio",
  "sZcf14": "Richmond",
  "sdjlqH": "Mississauga",
  "search.activities_dropdown.popular_activities": "See all popular activities",
  "search.activity-input.no-activity": "We don't recognize that activity. Try describing it differently",
  "search.activity-input.placeholder": "Enter your activity",
  "search.activity_modal.popular_activities": "Popular Activities",
  "search.date_time_modal.date_and_time": "Date & Time",
  "search.error_dropdown.dont_recognize_activity": "We don't recognize that activity. Try describing it differently or",
  "search.error_dropdown.popular_activities": "pick from popular activities.",
  "search.location_dropdown.powered_google": "powered by Google",
  "search.location_email_dropdown.adding_unique_spaces": "We're adding unique spaces in cities all over the world. {link} and you'll be the first one to know.",
  "search.location_email_dropdown.check_them_out": "{length} cities, check them out.",
  "search.location_email_dropdown.is_not_there": "Peerspace is not there yet but we're live in",
  "search.location_email_dropdown.leave_email": "Leave your email",
  "search.location_error_dropdown.dont_recognize": "We don't recognize that location",
  "search.results.total_price_on_serp.availabile_in_checkout_copy": "available in checkout",
  "search.results.total_price_on_serp.before_taxes_label": "before taxes",
  "search.results.total_price_on_serp.cleaning_fee_label": "Cleaning fee",
  "search.results.total_price_on_serp.hour_label": "hour",
  "search.results.total_price_on_serp.hourly_price_discount_label": "8+ hour discount",
  "search.results.total_price_on_serp.hourly_price_discount_modification": "8+ hour discount ({pctDiscount}%)",
  "search.results.total_price_on_serp.hourly_price_label": "Hourly price",
  "search.results.total_price_on_serp.hourly_price_tier_modification": "Hourly price for {tier} guests",
  "search.results.total_price_on_serp.hourly_price_tier_modification_default": "For {tier} guests",
  "search.results.total_price_on_serp.hours_label": "hours",
  "search.results.total_price_on_serp.including_taxes_label": "including taxes",
  "search.results.total_price_on_serp.pay_part_now_copy": "Pay part now, part later",
  "search.results.total_price_on_serp.price_details_label": "Price details",
  "search.results.total_price_on_serp.processing_fee": "Peerspace’s processing fee and applicable taxes will be calculated in checkout.",
  "search.results.total_price_on_serp.processing_fee_label": "Processing fee",
  "search.results.total_price_on_serp.total_before_taxes_label": "Est. total before taxes",
  "search.results.total_price_on_serp.total_including_taxes_label": "Est. total including taxes",
  "search.results.total_price_on_serp.total_label": "total",
  "search.search_date_time_hoc.empty_date": "Please select a date.",
  "search.search_date_time_hoc.filter_error": "We encountered an error with this filter.",
  "search_modal.search_modal.find_space": "Find a space",
  "shared-component.avatar-edit.image-alt-text": "upload avatar img",
  "shared-components.main-tray-datetime-picker.any": "Any",
  "shared-components.main-tray-datetime-picker.clear": "Clear",
  "shared-components.main-tray-datetime-picker.date": "Date",
  "shared-components.main-tray-datetime-picker.end-time": "End time",
  "shared-components.main-tray-datetime-picker.label": "When?",
  "shared-components.main-tray-datetime-picker.start-time": "Start time",
  "shared-components.mobile-datetime-picker.Edit": "Edit",
  "shared-components.mobile-datetime-picker.select-date": "Select date",
  "shared-components.mobile-time-picker.end-time": "End time",
  "shared-components.mobile-time-picker.start-time": "Start time",
  "shared-components.structured_attendees.hour_short": "hr",
  "shared-components.toast.text": "Changes saved",
  "shared.alcohol_beverages.event_faq_answers_const.any_alcohol": "Any type of alcohol",
  "shared.alcohol_beverages.event_faq_answers_const.bring_alcohol_allowed": "Guests can bring their own alcohol",
  "shared.alcohol_beverages.event_faq_answers_const.bring_alcohol_not_allowed": "Guests are not allowed to bring their own alcohol",
  "shared.alcohol_beverages.event_faq_answers_const.licensed_liquor": "Beer, wine, and seltzers only. Liquor must be served by a licensed vendor.",
  "shared.alcohol_beverages.event_faq_answers_const.liquor_not_allowed": "Beer, wine, and seltzers only. Liquor is not allowed.",
  "shared.alcohol_beverages.event_faq_answers_const.no_alcohol_allowed": "Alcohol consumption is not allowed in the space",
  "shared.alcohol_beverages.event_faq_const.alcohol_must_be_served_by_licensed_vendor": "All alcohol must be served by a licensed vendor",
  "shared.alcohol_beverages.event_faq_const.can_purchase_alcohol_at_full_service_bar": "Alcohol is available for purchase at our full service bar on-site",
  "shared.alcohol_beverages.event_faq_const.can_purchase_beer_wine_at_bar": "Beer and wine is available for purchase at our bar on-site",
  "shared.alcohol_beverages.event_faq_const.other_alcohol_consumption_rules": "Other rules",
  "shared.av_music_form.event_faq_const.is_amplified_music_allowed": "Amplified music is allowed",
  "shared.av_music_form.event_faq_const.is_connected_amplified_music_allowed": "Guests may amplify music by connecting a personal device to speakers within the space",
  "shared.av_music_form.event_faq_const.is_dj_allowed": "DJs are allowed",
  "shared.av_music_form.event_faq_const.is_live_music_allowed": "Live music is allowed",
  "shared.av_music_form.event_faq_const.microphones": "Microphones",
  "shared.av_music_form.event_faq_const.misc_av_equipment": "Other AV equipment",
  "shared.av_music_form.event_faq_const.projector": "Projector",
  "shared.av_music_form.event_faq_const.speakers": "Speakers",
  "shared.av_music_form.event_faq_const.television": "Television",
  "shared.cant_sync_options.dont_know_how": "I don't how to import my calendar",
  "shared.cant_sync_options.dont_want_to": "I don't want to import or sync any calendars",
  "shared.cant_sync_options.no_access": "I can't access the other calendar right now",
  "shared.cant_sync_options.no_time": "I don't have time right now",
  "shared.cant_sync_options.not_compatible": "My calendar is not compatible with Peerspace",
  "shared.complete_event_faq_modal.body_cop": "Detailed FAQs on food, beverage, and more boost search visibility and convert bookings with less back and forth.",
  "shared.complete_event_faq_modal.heading": "Boost your visibility in search with Event FAQs",
  "shared.complete_event_faq_modal>cta": "Update FAQs",
  "shared.dont_know_how_to_import.btn_text": "No, I don't want reminders",
  "shared.email_choice": "Email",
  "shared.event_activities.event_faq_const.arcade_games": "Arcade Games",
  "shared.event_activities.event_faq_const.darts": "Darts",
  "shared.event_activities.event_faq_const.is_21st_bday_prohibited": "21st birthday party",
  "shared.event_activities.event_faq_const.is_after_party_prohibited": "After party",
  "shared.event_activities.event_faq_const.is_album_release_party_prohibited": "Album release party",
  "shared.event_activities.event_faq_const.is_bachelorette_bachelor_party_prohibited": "Bachelorette and bachelor parties",
  "shared.event_activities.event_faq_const.is_concerts_performances_prohibited": "Concert or live performances",
  "shared.event_activities.event_faq_const.is_holiday_parties_info": "Includes: Halloween Party, Thanksgiving Party, Holiday Party, Christmas Party, New Years Eve Party",
  "shared.event_activities.event_faq_const.is_holiday_parties_prohibited": "Holiday parties",
  "shared.event_activities.event_faq_const.is_influencer_event_prohibited": "Influencer event",
  "shared.event_activities.event_faq_const.is_kids_birthday_party_prohibited": "Kids birthday party",
  "shared.event_activities.event_faq_const.is_party_prohibited": "Party",
  "shared.event_activities.event_faq_const.is_sports_viewing_party_prohibited": "Sporting event viewing party",
  "shared.event_activities.event_faq_const.karaoke": "Karaoke",
  "shared.event_activities.event_faq_const.misc_activities": "Other activities",
  "shared.event_activities.event_faq_const.other_prohibited_activity": "Other activities",
  "shared.event_activities.event_faq_const.ping_pong_table": "Ping pong table",
  "shared.event_activities.event_faq_const.pool_table": "Pool table",
  "shared.event_activities.event_faq_const.shuffleboard": "Shuffleboard",
  "shared.event_activities_form.amenities_note_link": "here",
  "shared.event_activities_form.loud_music_warning_learn_more": "Learn more",
  "shared.event_activities_form.loud_music_warning_residential": "residential",
  "shared.event_activities_form.residential_warning_heavy": "Residential Spaces",
  "shared.event_activities_form.residential_warning_learn_more": "Learn more",
  "shared.event_activities_form.social_event_policy": "Peerspace Social Event Policy",
  "shared.event_faq.section.alcohol": "Alcoholic Beverages",
  "shared.event_faq.section.av_music": "AV and Music",
  "shared.event_faq.section.chairs": "Chairs",
  "shared.event_faq.section.event_activities": "Event Activities",
  "shared.event_faq.section.food_beverage": "Food and Beverage",
  "shared.event_faq.section.food_prep_rules": "Rules for cooking and food preparation",
  "shared.event_faq.section.food_rules": "Rules for food and non-alcoholic beverages",
  "shared.event_faq.section.furniture": "Furniture",
  "shared.event_faq.section.kitchen_amenities": "Kitchen Amenities",
  "shared.event_faq.section.kitchen_setups": "Available kitchen setups",
  "shared.event_faq.section.restrooms": "Restrooms",
  "shared.event_faq.section.restrooms_and_facilities": "Restrooms and facilities",
  "shared.event_faq.section.rules": "Event Rules",
  "shared.event_faq.section.soft_seating": "Soft Seating",
  "shared.event_faq.section.tables": "Tables",
  "shared.event_rules_form.av_rules": "Rules for AV and music",
  "shared.event_rules_form.available_av_equipment": "Available AV equipment",
  "shared.event_rules_form.event_faq_answers_const.has_no_flexible_hours": "No, hours are not flexible",
  "shared.event_rules_form.event_faq_answers_const.hours_adjusted_upon_request": "Yes, hours may be adjusted upon request",
  "shared.event_rules_form.event_faq_const.are_open_flames_allowed": "Open flames are allowed",
  "shared.event_rules_form.event_faq_const.are_pets_allowed": "Pets are allowed",
  "shared.event_rules_form.event_faq_const.are_ticketed_events_allowed": "Ticketed events are allowed",
  "shared.event_rules_form.event_faq_const.has_quiet_hours": "No restrictions on noise during your space's operating hours",
  "shared.event_rules_form.event_faq_const.is_glitter_allowed": "Confetti or glitter are allowed",
  "shared.event_rules_form.event_faq_const.is_hired_security_required": "Large events require hired security",
  "shared.event_rules_form.event_faq_const.is_smoking_allowed": "Smoking is allowed",
  "shared.event_rules_form.event_faq_const.loud_music_ends_by": "Any loud music or noise must end by",
  "shared.event_rules_form.event_faq_const.other_event_rules": "Other event rules",
  "shared.event_rules_form.event_rules_header": "Event related rules and restrictions",
  "shared.event_rules_form.flexible_hours": "Are your bookable hours flexible?",
  "shared.event_rules_form.quiet_hours_header": "Does your space have quiet hours?*",
  "shared.faq_form.alcohol_consumption_placeholder": "Please describe your rules regarding alcohol consumption...",
  "shared.faq_form.amenities_note": "Amenities available for a fee must be added as an add-on item {addOnLink}",
  "shared.faq_form.chairs_tooltip": "Total chairs. Describe styles of chairs in the description below.",
  "shared.faq_form.cups_tooltip.cups_tooltip": "Amount of cups available to guests during their booking.",
  "shared.faq_form.eventFaqNux": "Set up your FAQ",
  "shared.faq_form.eventFaqTocHeader": "Set up your FAQ",
  "shared.faq_form.eventFaqTocSubheader": "Answer frequently asked questions and rules about event bookings",
  "shared.faq_form.event_rules_info": "All events are subject to the {socialEventPolicyLink}. Event rules are considered part of your host rules which guests must agree to before booking your space.",
  "shared.faq_form.exit_button_text": "Save and exit",
  "shared.faq_form.loud_music_warning": "* All social events at {residentialSpaces} spaces must start prior to 9:00 pm and end no later than 12:00 am (local time), inclusive of set-up and clean-up time. {socialEventPolicyLink}",
  "shared.faq_form.next_button_text": "Next",
  "shared.faq_form.other_activities_placeholder": "Please describe any other activities available in your space...",
  "shared.faq_form.other_av_equipment": "Please describe any other AV equipment...",
  "shared.faq_form.other_event_rules_placeholder": "Please describe any other rules regarding event bookings...",
  "shared.faq_form.other_food_prep_rules_placeholder": "Please describe your rules regarding cooking and food preparation...",
  "shared.faq_form.other_food_rules_placeholder": "Please describe your rules regarding food and non-alcoholic beverages...",
  "shared.faq_form.other_prohibited_activities_placeholder": "Please describe your any other activities you’d prefer to not host...",
  "shared.faq_form.other_prohibited_activities_tips": "We'll show these as activities you'd prefer to not host. Guests can still book them, so monitor and choose to accept or decline bookings.",
  "shared.faq_form.other_prohibited_activities_tips_guest": "Hosts may not accept your booking if you choose to book for these activities.",
  "shared.faq_form.place_setting_tooltip": "Maximum amount of guests the available place settings can accommodate.",
  "shared.faq_form.place_settings_subheader": "Plates, utensils, etc.",
  "shared.faq_form.residential_warning": "* {residentialSpaces} are not allowed to hold ticketed events. {socialEventPolicyLink}",
  "shared.faq_form.restroom_tooltip": "Amount of restrooms (including stalls) available for guests during their booking.",
  "shared.faq_form.serving_utensils_subheader": "Serving spoons, tongs, etc..",
  "shared.faq_form.soft_seating_tooltip": "Maximum seating capacity for your soft seating (e.g. a sofa that seats 3, plus 2 lounge chairs, would be a seating capacity of 5).",
  "shared.faq_form.tables_tooltip": "Total tables. Describe types of tables and seating capacity in the description below.",
  "shared.faq_form.text_area_description": "Add a short description...",
  "shared.faq_form.wine_glasses_tooltip": "Amount of wine glasses available to guests during their booking.",
  "shared.food_and_beverage.event_faq_answers_const.cooking_and_prep_allowed": "Cooking and food preparation is allowed on-site",
  "shared.food_and_beverage.event_faq_answers_const.licensed_food_beverage": "Food and non-alcoholic beverages must be provided by a licensed vendor",
  "shared.food_and_beverage.event_faq_answers_const.no_cooking_allowed": "No cooking is allowed on-site",
  "shared.food_and_beverage.event_faq_answers_const.no_outside_food_beverage": "No outside food, guests are allowed to bring specialty items (ie: cakes, dessert, etc)",
  "shared.food_and_beverage.event_faq_answers_const.on_site_food_beverage": "Food and non-alcoholic beverages are available for purchase on-site only",
  "shared.food_and_beverage.event_faq_answers_const.only_food_prep": "Only food preparation is allowed on-site",
  "shared.food_and_beverage.event_faq_answers_const.other_food_and_beverage_rules": "Other",
  "shared.food_and_beverage.event_faq_answers_const.other_food_prep_rules": "Other",
  "shared.food_and_beverage.event_faq_answers_const.outside_food_beverage_allowed": "Outside food and non-alcoholic beverages allowed",
  "shared.food_and_beverage.event_faq_const.commercial_kitchen": "Commercial Kitchen",
  "shared.food_and_beverage.event_faq_const.cups_glasses": "Cups",
  "shared.food_and_beverage.event_faq_const.kitchenette": "Kitchenette",
  "shared.food_and_beverage.event_faq_const.place_settings": "Place settings",
  "shared.food_and_beverage.event_faq_const.prep_area": "Prep area",
  "shared.food_and_beverage.event_faq_const.serving_utensils": "Serving utensils",
  "shared.food_and_beverage.event_faq_const.wine_glasses": "Wine glasses",
  "shared.food_and_beverage.full_kitchen": "Full kitchen",
  "shared.furniture_form.event_faq_const.chairs": "Dining chairs, stools, etc",
  "shared.furniture_form.event_faq_const.soft_seating": "Sofas, lounge chairs, etc",
  "shared.furniture_form.event_faq_const.tables": "Dining tables, cocktail tables, etc",
  "shared.monthly_reminder.btn_text": "Yes, remind me monthly",
  "shared.notification_choice.header": "How would you like to receive your reminders?",
  "shared.parking_faq.description": "Parking description",
  "shared.parking_faq.is_available": "No parking options at this space",
  "shared.parking_faq.label": "Parking",
  "shared.parking_faq.types": "Parking options",
  "shared.parking_types.free_on_premise": "Free onsite parking",
  "shared.parking_types.free_street": "Free street parking",
  "shared.parking_types.metered_street": "Metered street parking",
  "shared.parking_types.nearby_lot": "Nearby parking lot",
  "shared.parking_types.paid_on_premise": "Paid onsite parking",
  "shared.parking_types.valet": "Valet",
  "shared.phone_number_add_update_your_phone_skip_btn": "Skip, I'll do this later",
  "shared.phone_number_add_update_your_phone_subheader": "For better security and seamless communication with guests, phone number verification will {emphasizedText}.",
  "shared.phone_number_add_update_your_phone_subheader_emphasized": "soon be required",
  "shared.phone_number_modal.help_center": "Help Center",
  "shared.phone_number_verify_number_cta": "Verify my number",
  "shared.phone_verification.code_not_match_heading": "Your phone number was unable to be verified",
  "shared.phone_verification.code_not_match_text": "Verification code invalid. You have limited attempts, please confirm the number entered is correct or {contact} for help.",
  "shared.phone_verification_modal.contact_support": "contact support",
  "shared.phone_verification_okay_btn": "Okay",
  "shared.phone_verification_unable_to_verify_text": "We require phone number verification to protect your account. Please try again later.",
  "shared.production_utils.agreement": "Peerspace Services Agreement",
  "shared.production_utils.all_age_allowed": "All ages are allowed in the space",
  "shared.production_utils.host_rules": "Host rules",
  "shared.production_utils.insurance": "Production insurance is required",
  "shared.production_utils.min_age_allowed": "Ages {answer}+",
  "shared.production_utils.move_furniture": "Furniture and decorations may be moved",
  "shared.production_utils.no_insurance": "Production insurance is not required",
  "shared.production_utils.no_move_furniture": "No moving furniture and decorations",
  "shared.production_utils.no_nudity": "No nudity allowed",
  "shared.production_utils.no_smoke_machine": "No smoke machines allowed",
  "shared.production_utils.nudity": "Nudity is allowed",
  "shared.production_utils.recording_device": "Recording devices in bathrooms or dressing rooms are prohibited by the {link}.",
  "shared.production_utils.rules": "General Rules",
  "shared.production_utils.smoke_machine": "Smoke machines are allowed",
  "shared.push_notifications_choice": "Push Notifications",
  "shared.restroom_form.has_ada_restrooms": "ADA accessible restrooms",
  "shared.restroom_form.has_nursing_rooms": "Nursing or parent room",
  "shared.restroom_form.how_many_restrooms": "Restrooms on-site",
  "shared.select-an-option.error-text": "Please select at least one, or go back.",
  "shared.sms_choice": "SMS",
  "shared.survey_complete.header": "Thanks for Letting Us Know",
  "shared.survey_complete.header_link": "Feel free to contact us here for help.",
  "shared.survey_complete.header_text": "We want to help you keep your availability updated in Peerspace.",
  "shared.want_a_reminder.header": "Want a reminder to manually block your calendar?",
  "shared.want_a_reminder.header_text": "If you can’t sync a calendar, manually blocking is a great way to keep your availability updated on Peerspace and receive more bookings.",
  "shared.weekly_reminder.btn_text": "Yes, remind me weekly",
  "shared.why_cant_sync.button_done": "Done",
  "shared.why_cant_sync.header": "Why can't you sync your calendar?",
  "shared.why_cant_sync.header_text": "Hosts with synced calendars tend to get more bookings.",
  "shared_component.calendar.last_updated.any_days": "Updated {days} days ago",
  "shared_component.calendar.last_updated.any_week": "Updated 1 week ago",
  "shared_component.calendar.last_updated.any_weeks": "Updated {weeks} weeks ago",
  "shared_component.calendar.last_updated.more_then_month": "Updated more than 4 weeks ago",
  "shared_component.calendar.last_updated.one_day": "Updated 1 day ago",
  "shared_component.footer.about": "About",
  "shared_component.footer.activities": "Activities",
  "shared_component.footer.ambassadors": "Ambassador Program",
  "shared_component.footer.blog": "Blog",
  "shared_component.footer.california_privacy_link": "California Privacy",
  "shared_component.footer.careers": "Careers",
  "shared_component.footer.community": "Community",
  "shared_component.footer.company": "Company",
  "shared_component.footer.countries": "Countries",
  "shared_component.footer.covid_measures": "COVID-19 Measures",
  "shared_component.footer.download": "Download",
  "shared_component.footer.download_logo": "download logo",
  "shared_component.footer.explore": "Explore",
  "shared_component.footer.footer_logo": "Peerspace footer logo",
  "shared_component.footer.help_center": "Help Center",
  "shared_component.footer.host": "Host",
  "shared_component.footer.list_your_space": "List your space",
  "shared_component.footer.locations": "Locations",
  "shared_component.footer.press": "Press",
  "shared_component.footer.privacy": "Privacy",
  "shared_component.footer.report_vulnerability": "Report Vulnerability",
  "shared_component.footer.resources": "Resources",
  "shared_component.footer.social": "Social",
  "shared_component.footer.support": "Support",
  "shared_component.footer.terms": "Terms",
  "shared_component.footer.trust_safety": "Trust and Safety",
  "shared_component.footer.your_privacy_choices": "Your privacy choices",
  "shared_component.language_country_selector.error_msg": "Unknown error occured. Please try again.",
  "shared_component.language_country_selector.header": "Customize your experience",
  "shared_component.language_country_selector.subheader": "Set your preferred language and region",
  "shared_component.mobile-activity-input.placeholder": "Enter your activity",
  "shared_component.mobile-date-time-picker.date": "Date",
  "shared_component.mobile_activity_input.label": "What are you planning?",
  "shared_component.nav.add_ons": "Add-ons",
  "shared_component.nav.add_payout": "Add Payout Info",
  "shared_component.nav.add_space": "Add a Space",
  "shared_component.nav.boards": "Boards",
  "shared_component.nav.bookings": "Bookings",
  "shared_component.nav.calendar": "Calendar",
  "shared_component.nav.community": "Community",
  "shared_component.nav.earn_50": "Earn $50",
  "shared_component.nav.earn_50_alt": "gift",
  "shared_component.nav.help": "Help",
  "shared_component.nav.inbox": "Inbox",
  "shared_component.nav.list_space": "List Your Space",
  "shared_component.nav.listings": "Listings",
  "shared_component.nav.login": "Log In",
  "shared_component.nav.logo_alt": "Peerspace | Unique venues for meetings, events, photo & film shoots",
  "shared_component.nav.logout": "Log Out",
  "shared_component.nav.new": "NEW!",
  "shared_component.nav.payments": "Payments",
  "shared_component.nav.payout_blocked": "Payouts Blocked",
  "shared_component.nav.profile": "Profile",
  "shared_component.nav.reviews": "Reviews",
  "shared_component.nav.search": "Search",
  "shared_component.nav.signup": "Sign Up",
  "shared_component.nav.toggle_nav": "Toggle navigation",
  "shared_component.navba.listings_nav_item": "Listings",
  "shared_component.navbar.addons_nav_item": "Add-ons",
  "shared_component.navbar.boards_nav_item": "Boards",
  "shared_component.navbar.bookings_nav_item": "Bookings",
  "shared_component.navbar.browse_spaces_nav_item": "Browse Spaces",
  "shared_component.navbar.calendar_nav_item": "Calendar",
  "shared_component.navbar.community_nav_item": "Community",
  "shared_component.navbar.help_nav_item": "Help",
  "shared_component.navbar.inbox_nav_item": "Inbox",
  "shared_component.navbar.list_your_space_nav_item": "List Your Space",
  "shared_component.navbar.login_nav_item": "Log In",
  "shared_component.navbar.logo_image_alt": "Peerspace | Unique venues for meetings, events, photo & film shoots",
  "shared_component.navbar.logout_nav_item": "Log Out",
  "shared_component.navbar.notification_nav_badge": "NEW!",
  "shared_component.navbar.payments_nav_item": "Payments",
  "shared_component.navbar.profile_nav_item": "Profile",
  "shared_component.navbar.referral_nav_item": "Earn $50",
  "shared_component.navbar.reviews_nav_item": "Reviews",
  "shared_component.navbar.search_text": "Search",
  "shared_component.navbar.signup_nav_item": "Sign Up",
  "shared_component.navbar.toggle_nav_button": "Toggle navigation",
  "shared_component.signup_manager.book_details_header": "Sign up to book this space",
  "shared_component.signup_manager.book_details_subheader": "It’s almost yours! Just let the host know who’s asking.",
  "shared_component.signup_manager.default_details_header": "Join Peerspace",
  "shared_component.signup_manager.default_details_subheader": "Book unique spaces directly from local hosts",
  "shared_component.signup_manager.host_details_header": "Create an account to list your space",
  "shared_component.signup_manager.message_details_header": "Sign up to message hosts",
  "shared_component.signup_manager.message_details_subheader": "Let the host know who’s inquiring",
  "shared_component.signup_manager.save_details_header": "Sign up to save this space",
  "shared_component.signup_manager.save_details_subheader": "We’ll keep it safe so you can come back to it later.",
  "shared_components.activity-input.activity-input-header": "What are you planning?",
  "shared_components.activity-input.activity-input-label": "What are you planning?",
  "shared_components.activity-input.activity-input-placeholder": "Enter your activity",
  "shared_components.activity-input.location-input-label": "Where?",
  "shared_components.activity-input.no-activity-message": "We don't recognize that activity.",
  "shared_components.activity-input.no-activity-message-subheader": "Try describing it differently and select from our activities.",
  "shared_components.activity-modal.popular_activities": "Popular Activities",
  "shared_components.add_first_and_last_name.add_name": "Add Your Name",
  "shared_components.add_first_and_last_name.button_save": "Save",
  "shared_components.add_first_and_last_name.first_name": "First Name",
  "shared_components.add_first_and_last_name.first_use_more_chars": "Please use at least two or more characters",
  "shared_components.add_first_and_last_name.input_first_name_placeholder": "John",
  "shared_components.add_first_and_last_name.input_last_name_placeholder": "Doe",
  "shared_components.add_first_and_last_name.last_name": "Last Name",
  "shared_components.add_first_and_last_name.last_use_more_chars": "Please use at least two or more characters",
  "shared_components.avatar_upload.add_photo": "Add a profile photo",
  "shared_components.avatar_upload.error_message": "Please try uploading your image again.",
  "shared_components.avatar_upload.please_upload": "Please upload a profile photo.",
  "shared_components.avatar_upload.update_photo": "Update photo",
  "shared_components.cleaning_badge.text": "Enhanced COVID-19 Measures",
  "shared_components.cleaning_types.arrows": "Narrow passages have arrows for bi-directional traffic",
  "shared_components.cleaning_types.capacity_guidelines": "Capacity is limited based on governmental guidelines",
  "shared_components.cleaning_types.cdc_guidelines": "The space is cleaned and disinfected in accordance with guidelines from local health authorities",
  "shared_components.cleaning_types.certified_air_filters": "Space has HEPA-certified air filters",
  "shared_components.cleaning_types.checklist": "Detailed checklist of updated cleaning procedure. {link}",
  "shared_components.cleaning_types.cleaning_measures_heading": "What additional measures are you taking to keep your space clean?",
  "shared_components.cleaning_types.cleaning_soft_materials": "Soft, porous materials have been properly cleaned or removed",
  "shared_components.cleaning_types.disinfectant_wipes": "Disinfecting wipes or spray and paper towels",
  "shared_components.cleaning_types.disinfecting_surfaces": "High touch surfaces and shared amenities have been disinfected",
  "shared_components.cleaning_types.divider_text": "or",
  "shared_components.cleaning_types.download_checklist": "Download checklist",
  "shared_components.cleaning_types.download_guidelines": "Download guidelines",
  "shared_components.cleaning_types.gloves": "Disposable gloves",
  "shared_components.cleaning_types.hand_sanitizer": "Hand Sanitizer",
  "shared_components.cleaning_types.licensed_cleaner": "A licensed professional cleaner is hired between bookings",
  "shared_components.cleaning_types.masks": "Disposable masks / face coverings",
  "shared_components.cleaning_types.outdoor_space": "Space has additional space outdoors",
  "shared_components.cleaning_types.outdoor_ventilation": "Space has access to outdoor air ventilation",
  "shared_components.cleaning_types.physical_distance_header": "What have you done to help guests maintain physical distance in your space?",
  "shared_components.cleaning_types.physical_distance_listing_header": "Physical distance",
  "shared_components.cleaning_types.physical_distance_listing_subheader": "The space has the following features:",
  "shared_components.cleaning_types.printouts": "COVID-19 guest guidelines print outs. {link}",
  "shared_components.cleaning_types.protective_gear_header": "What additional protective gear do you provide to your guests?",
  "shared_components.cleaning_types.protective_gear_listing_header": "Protective gear",
  "shared_components.cleaning_types.protective_gear_listing_subheader": "The following equipment is provided for every guest:",
  "shared_components.cleaning_types.reconfigured_space": "Space has been reconfigured to allow for physical distance",
  "shared_components.cleaning_types.signage_header": "What signage have you added to keep your guests informed?",
  "shared_components.cleaning_types.signage_listing_header": "Signage",
  "shared_components.cleaning_types.signage_listing_subheader": "The space has informational signage including:",
  "shared_components.cleaning_types.six_foot_markers": "Common areas have 6-foot (2-metre) markers on floors",
  "shared_components.cleaning_types.spacing_bookings": "Bookings are spaced apart to allow for enhanced cleaning",
  "shared_components.cloudinary.Done": "Done",
  "shared_components.cloudinary.abort_all": "Abort all",
  "shared_components.cloudinary.aborted": "Aborted",
  "shared_components.cloudinary.allowed_files_formats": "File format not allowed",
  "shared_components.cloudinary.browse": "Browse",
  "shared_components.cloudinary.cancel_all_uploads": "Closing will cancel all uploads, Are you sure?",
  "shared_components.cloudinary.crop_button": "Crop",
  "shared_components.cloudinary.crop_title": "Crop",
  "shared_components.cloudinary.done": "Done",
  "shared_components.cloudinary.drag_corner_to_resize": "Drag corner to resize",
  "shared_components.cloudinary.drag_handle_to_resize": "Drag handle to resize",
  "shared_components.cloudinary.drop_asset": "Drag and Drop an asset here",
  "shared_components.cloudinary.drop_assets": "Drag and Drop assets here",
  "shared_components.cloudinary.drop_file": "Drop a file to upload",
  "shared_components.cloudinary.drop_files": "Drop files to upload",
  "shared_components.cloudinary.error": "Error",
  "shared_components.cloudinary.error_loading_image": "Error loading image",
  "shared_components.cloudinary.file_size_too_large": "File size ({size}) exceeds maximum allowed ({allowed})",
  "shared_components.cloudinary.file_too_large": "File is too large",
  "shared_components.cloudinary.file_too_small": "File is too small",
  "shared_components.cloudinary.max_dimensions_validation": "Image dimensions ({width}X{height}) are bigger than the maximum allowed: ({maxWidth}X{maxHeight})",
  "shared_components.cloudinary.max_number_of_files": "Maximum number of files exceeded",
  "shared_components.cloudinary.menu_files": "My Files",
  "shared_components.cloudinary.min_dimensions_validation": "Image dimensions ({width}X{height}) are smaller than the minimum required: ({minWidth}X{minHeight})",
  "shared_components.cloudinary.num_failed": "{num} failed",
  "shared_components.cloudinary.num_uploaded": "{num} uploaded",
  "shared_components.cloudinary.or": "Or",
  "shared_components.cloudinary.reset": "Reset",
  "shared_components.cloudinary.retry_failed": "Retry failed",
  "shared_components.cloudinary.show_completed": "Show completed",
  "shared_components.cloudinary.skip": "Skip",
  "shared_components.cloudinary.status_uploading": "Uploading...",
  "shared_components.cloudinary.unavailable": "NA",
  "shared_components.cloudinary.upload_more": "Upload more",
  "shared_components.cloudinary.upload_queue": "Upload Queue",
  "shared_components.cloudinary.uploaded": "Uploaded",
  "shared_components.cloudinary.uploading": "Uploading",
  "shared_components.cloudinary.uploading_assets": "Uploading Assets",
  "shared_components.cloudinary.uploading_num_assets": "Uploading {num} Assets",
  "shared_components.cloudinary.uploads_running": "There are running uploads. Click OK to abort.",
  "shared_components.cloudinary.yes": "Yes",
  "shared_components.covid_health_and_safety_banner.covid_description": "We’ve provided guidelines and enhanced safety measures for hosts so guests can book with peace of mind.",
  "shared_components.covid_health_and_safety_banner.learn_more": "Learn more",
  "shared_components.covid_health_and_safety_banner.title": "Our COVID-19 Health & Safety Measures",
  "shared_components.date_time_form.apply": "Apply",
  "shared_components.date_time_form.date_error": "Please enter a date",
  "shared_components.date_time_form.end_error": "Please enter an end time",
  "shared_components.date_time_form.start_error": "Please enter a start time",
  "shared_components.description.more_text": "more",
  "shared_components.disclaimer.accept_booking": "you agree to {terms_link}, which includes our {community_guidelines}, {social_event_policy}, and {cancellation_policy}.",
  "shared_components.disclaimer.accept_booking_new_tab": "you agree to {terms_link}, which includes the {community_guidelines}, and {cancellation_policy}.",
  "shared_components.disclaimer.banking_terms": "you agree to {terms_link}, and {stripe_link} which includes the {connected_link}.",
  "shared_components.disclaimer.cancel_booking": "you agree to {terms_link}, which includes the {cancellation_policy}.",
  "shared_components.disclaimer.cancel_booking_credits": "Peerspace Credits will be automatically issued to your Peerspace account. Once cancelled, no further changes or reversals may be made. You agree to {terms_link}, which includes the {cancellation_policy}.",
  "shared_components.disclaimer.cancel_instant_book": "you agree to {instant_book} as well as {terms_link}, which includes the {cancellation_policy}.",
  "shared_components.disclaimer.cancellation_policy": "Cancellation and Refund Policy",
  "shared_components.disclaimer.click_prefix": "By clicking",
  "shared_components.disclaimer.community_guidelines": "Community Guidelines",
  "shared_components.disclaimer.credit_card": "you agree to {terms_link}, and {stripe_link} which includes the {connected_link}.",
  "shared_components.disclaimer.direct_deposit": "you agree to {terms_link}, and {stripe_link} which includes the {connected_link}.",
  "shared_components.disclaimer.fees_overview": "Fees Overview",
  "shared_components.disclaimer.instant_book": "Peerspace’s Instant Book Guidelines",
  "shared_components.disclaimer.instant_book_req": "you also agree to {terms_link}, which includes the {community_guidelines} and {cancellation_policy}.",
  "shared_components.disclaimer.peerspace_service_agreement": "Peerspace's Services Agreement",
  "shared_components.disclaimer.privacy_policy": "Privacy Policy",
  "shared_components.disclaimer.request_booking": "you agree to {terms_link}, which includes the {community_guidelines}, and {cancellation_policy}.",
  "shared_components.disclaimer.request_booking_new_tab": "you also agree to {terms_link}, which includes the {community_guidelines} and {cancellation_policy}.",
  "shared_components.disclaimer.service_agreement": "Services Agreement",
  "shared_components.disclaimer.signup_terms": "you agree to {terms_link} and {privacy_link}.",
  "shared_components.disclaimer.social_event_policy": "Social Event Policy",
  "shared_components.disclaimer.stripe_service_agreement": "Stripe's Services Agreement",
  "shared_components.disclaimer.transactable_terms": "you accept and agree to Peerspace's {terms_link}, {privacy_link}, {cancellation_policy}, and {fees_overview}, and agree to abide by the {community_guidelines}.",
  "shared_components.disclaimer.verify": "you agree to {terms_link}.",
  "shared_components.error_data.account_number_au_empty_error": "Account number is required.",
  "shared_components.error_data.account_number_au_format_error": "Enter your Account Number as 5-9 numbers without punctuation.",
  "shared_components.error_data.attendees_empty_error": "Please enter the number of attendees.",
  "shared_components.error_data.attendees_range_error": "The number of attendees must be between 1 and 100,000.",
  "shared_components.error_data.bsb_number_empty_error": "BSB is required.",
  "shared_components.error_data.bsb_number_format_error": "Enter your BSB as 6 numbers without punctuation.",
  "shared_components.error_data.empty_cancellation_reason_error": "Please fill in your response",
  "shared_components.error_data.enter_name": "Enter cardholder's name and last name.",
  "shared_components.error_data.iban_empty_error": "IBAN is required.",
  "shared_components.error_data.iban_format_error": "Enter your IBAN of up to 34 characters without punctuation.",
  "shared_components.error_data.msg_host_empty_error": "Please enter a message.",
  "shared_components.input_data.account_number_au_label": "Bank Account Number",
  "shared_components.input_data.account_number_au_placeholder": "Bank Account Number",
  "shared_components.input_data.all_day_label": "All day",
  "shared_components.input_data.board_name_empty_error": "Please enter the name of your project.",
  "shared_components.input_data.board_name_max_error": "Maximum is 35 characters.",
  "shared_components.input_data.board_name_min_error": "Minimum is 2 characters.",
  "shared_components.input_data.bsb_number_label": "BSB Number",
  "shared_components.input_data.bsb_number_placeholder": "BSB Number",
  "shared_components.input_data.comment_empty_error": "Please enter a comment",
  "shared_components.input_data.email_empty_error": "Please enter your email.",
  "shared_components.input_data.email_label": "Email",
  "shared_components.input_data.email_valid_error": "Please enter a valid email.",
  "shared_components.input_data.flex_time_label": "My dates / times are flexible",
  "shared_components.input_data.iban_number_label": "IBAN",
  "shared_components.input_data.iban_number_placeholder": "IBAN",
  "shared_components.input_data.job_title_placeholder": "Job Title",
  "shared_components.input_data.organization_placeholder": "Organization",
  "shared_components.input_data.password_empty_error": "Please enter your password.",
  "shared_components.input_data.password_format_error": "Your password needs to be at least 8 characters long and include a number.",
  "shared_components.input_data.password_label": "Password",
  "shared_components.input_data.password_placeholder": "Password",
  "shared_components.input_data.personal_email_placeholder": "Email",
  "shared_components.input_data.personal_message_error": "Please enter a personal message.",
  "shared_components.input_data.personal_message_label": "Include a personal message",
  "shared_components.input_data.personal_message_max_error": "Maximum is 1000 characters",
  "shared_components.input_data.personal_message_min_error": "Minimum is 15 characters.",
  "shared_components.input_data.personal_message_placeholder": "Check out the spaces I found on Peerspace and let me know what you think.",
  "shared_components.input_data.signup_password_placeholder": "Password",
  "shared_components.input_data.use_phone_number": "We will only use your phone number for booking updates.",
  "shared_components.input_error.enter_first_name": "Please enter your first name.",
  "shared_components.input_error.enter_last_name": "Please enter your last name.",
  "shared_components.input_error.error_first_name_long": "Is too long (maximum is 35 characters)",
  "shared_components.input_error.error_first_name_short": "Is too short (minimum is 2 characters)",
  "shared_components.input_error.error_last_name_long": "Is too long (maximum is 35 characters)",
  "shared_components.input_error.error_last_name_short": "Is too short (minimum is 2 characters)",
  "shared_components.insta_book.text": "Instant Book",
  "shared_components.interaction.save": "Save",
  "shared_components.invite_banner.body": "Send invites to easily communicate event hours, allow guests to RSVP, receive parking information and more.",
  "shared_components.invite_banner.button_label": "Invite guests",
  "shared_components.invite_banner.footer": "Send invites and save {discount} for you and your guests’ travel needs",
  "shared_components.invite_banner.footer_discount": "10% at booking.com",
  "shared_components.invite_banner.header": "Your booking is coming up, invite your guests!",
  "shared_components.invoice_page.charge_for_booking_text": "Charge for booking",
  "shared_components.invoice_page.credit_note_copy": "A credit note is a refund for taxes, often due to booking updates and cancellations.",
  "shared_components.invoice_page.gst": "GST",
  "shared_components.invoice_page.gst_charged": "GST charged",
  "shared_components.invoice_page.gst_charges": "GST charges",
  "shared_components.invoice_page.gst_credited": "GST credited",
  "shared_components.invoice_page.gst_details": "GST details",
  "shared_components.invoice_page.gst_hst": "GST/HST",
  "shared_components.invoice_page.gst_id": "GST ID",
  "shared_components.invoice_page.gst_reverse_charge_copy": "A reverse charge was applied to the GST on any booking where your GST was stored in your profile at the time the booking was accepted. You were not charged GST on these bookings.",
  "shared_components.invoice_page.hst": "HST",
  "shared_components.invoice_page.hst_charged": "HST charged",
  "shared_components.invoice_page.hst_charges": "HST charges",
  "shared_components.invoice_page.hst_credited": "HST credited",
  "shared_components.invoice_page.hst_details": "HST details",
  "shared_components.invoice_page.hst_id": "QST ID",
  "shared_components.invoice_page.hst_reverse_charge_copy": "A reverse charge was applied to the HST on any booking where your HST was stored in your profile at the time the booking was accepted. You were not charged HST on these bookings.",
  "shared_components.invoice_page.pst": "PST",
  "shared_components.invoice_page.pst_charged": "PST charged",
  "shared_components.invoice_page.pst_charges": "PST charges",
  "shared_components.invoice_page.pst_credited": "PST credited",
  "shared_components.invoice_page.pst_details": "PST details",
  "shared_components.invoice_page.pst_id": "PST ID",
  "shared_components.invoice_page.pst_reverse_charge_copy": "A reverse charge was applied to the PST on any booking where your PST was stored in your profile at the time the booking was accepted. You were not charged PST on these bookings.",
  "shared_components.invoice_page.qst": "QST",
  "shared_components.invoice_page.qst_charged": "QST charged",
  "shared_components.invoice_page.qst_charges": "QST charges",
  "shared_components.invoice_page.qst_credited": "QST credited",
  "shared_components.invoice_page.qst_details": "QST details",
  "shared_components.invoice_page.qst_id": "QST ID",
  "shared_components.invoice_page.qst_reverse_charge_copy": "A reverse charge was applied to the QST on any booking where your QST was stored in your profile at the time the booking was accepted. You were not charged QST on these bookings.",
  "shared_components.invoice_page.refund_for_booking_text": "Refund for booking",
  "shared_components.invoice_page.rst": "RST",
  "shared_components.invoice_page.rst_charged": "RST charged",
  "shared_components.invoice_page.rst_charges": "RST charges",
  "shared_components.invoice_page.rst_credited": "RST credited",
  "shared_components.invoice_page.rst_details": "RST details",
  "shared_components.invoice_page.rst_id": "RST ID",
  "shared_components.invoice_page.rst_reverse_charge_copy": "A reverse charge was applied to the RST on any booking where your RST was stored in your profile at the time the booking was accepted. You were not charged RST on these bookings.",
  "shared_components.invoice_page.sales_tax_details": "Sales tax details",
  "shared_components.invoice_page.vat": "VAT",
  "shared_components.invoice_page.vat_charged": "VAT charged",
  "shared_components.invoice_page.vat_charges": "VAT charges",
  "shared_components.invoice_page.vat_credited": "VAT credited",
  "shared_components.invoice_page.vat_details": "VAT details",
  "shared_components.invoice_page.vat_id": "VAT ID",
  "shared_components.invoice_page.vat_reverse_charge_copy": "A reverse charge was applied to the VAT on any booking where your VAT was stored in your profile at the time the booking was accepted. You were not charged VAT on these bookings.",
  "shared_components.listing_description.hide_btn": "Hide",
  "shared_components.listing_description.read_more_btn": "Read More",
  "shared_components.location-input.async-select-placeholder": "Enter a city or address",
  "shared_components.location-input.google": "Results powered by Google",
  "shared_components.location-input.location-input-header": "Where?",
  "shared_components.location-input.noLocation": "We don't recognize that location",
  "shared_components.location-input.noLocation-subheader": "Confirm your spelling is correct or try a different location.",
  "shared_components.login_manager.account_created_with_apple": "Your account was created with Apple. Please use Apple to log in.",
  "shared_components.login_manager.account_created_with_facebook": "Your account was created with Facebook. Please use Facebook to log in.",
  "shared_components.login_manager.account_created_with_google": "Your account was created with Google. Please use Google to log in.",
  "shared_components.login_manager.already_have_account": "Looks like you already have an account with us. Please log in using your email and password.",
  "shared_components.login_manager.already_taken_error": "{email} is already associated with an account. Please log in instead.",
  "shared_components.login_manager.apple_problem": "There was a problem connecting with Apple.",
  "shared_components.login_manager.continue_apple": "Continue with Apple",
  "shared_components.login_manager.continue_facebook": "Continue with Facebook",
  "shared_components.login_manager.continue_google": "Continue with Google",
  "shared_components.login_manager.did_not_match_login": "We did not match that login. Please try again or sign up instead.",
  "shared_components.login_manager.dont_have_account": "Don't have an account?",
  "shared_components.login_manager.email_different_login": "This email is associated with a different login method. Please login using your email and password.",
  "shared_components.login_manager.enter_valid_email_password": "Please enter a valid email and password.",
  "shared_components.login_manager.forgot_password": "Forgot Password",
  "shared_components.login_manager.incorrect_email_password": "Email and password combination is incorrect.",
  "shared_components.login_manager.log_in_button": "Log In",
  "shared_components.login_manager.login_using_apple_account": "Looks like you already have an account with us. Please log in using your Apple account.",
  "shared_components.login_manager.login_using_apple_email": "This email is associated with a different login method. Please login using your Apple account.",
  "shared_components.login_manager.login_using_facebook_account": "Looks like you already have an account with us. Please log in using your Facebook account.",
  "shared_components.login_manager.login_using_facebook_email": "This email is associated with a different login method. Please login using your Facebook account.",
  "shared_components.login_manager.login_using_google_account": "Looks like you already have an account with us. Please log in using your Google account.",
  "shared_components.login_manager.login_using_google_email": "This email is associated with a different login method. Please login using your Google account.",
  "shared_components.login_manager.no_facebook_account_error": "You don't have an account with us, please",
  "shared_components.login_manager.no_facebook_account_sign_up": "sign up",
  "shared_components.login_manager.no_google_account_error": "You don't have an account with us, please",
  "shared_components.login_manager.no_google_account_sign_up": "sign up",
  "shared_components.login_manager.please_log_in": "Please log in",
  "shared_components.login_manager.sign_up_button": "Sign Up",
  "shared_components.login_manager.something_wrong": "Something went wrong, please try again. If the problem persists please refresh.",
  "shared_components.login_manager.unexpected_error": "An unexpected error occurred. Please try again in a few minutes.",
  "shared_components.login_manager.welcome_back": "Welcome back",
  "shared_components.main-input.main-input-header": "Find a Space",
  "shared_components.new_label.cdc_guidelines": "New",
  "shared_components.page_login.account_created_with_google": "Your account was created with Google. Please use Google to log in.",
  "shared_components.page_login.account_exists_email": "This account already exists, please login with email.",
  "shared_components.page_login.apple_log_in": "Your account was created with Apple. Please use Apple to log in.",
  "shared_components.page_login.apple_problem": "There was a problem connecting with Apple.",
  "shared_components.page_login.continue_apple": "Continue with Apple",
  "shared_components.page_login.continue_facebook": "Continue with Facebook",
  "shared_components.page_login.dont_have_account": "You don't have an account with us, please {signUp}",
  "shared_components.page_login.email_password_incorrect": "Email and password combination is incorrect.",
  "shared_components.page_login.facebook_log_in": "Your account was created with Facebook. Please use Facebook to log in.",
  "shared_components.page_login.forgot_password": "Forgot Password",
  "shared_components.page_login.google_error": "Something went wrong. Please try again",
  "shared_components.page_login.log_in_button": "Log In",
  "shared_components.page_login.no_google_account_error": "You don't have an account with us, please",
  "shared_components.page_login.no_google_account_sign_up": "sign up",
  "shared_components.page_login.peerspace_login": "Log in to Peerspace",
  "shared_components.page_login.something_wrong": "Something went wrong, please try again. If the problem persists please refresh.",
  "shared_components.page_login.unexpected_error": "An unexpected error occurred. Please refresh the page and try again.",
  "shared_components.page_login.welcome_back": "sign up",
  "shared_components.price_box.from": "from",
  "shared_components.price_box.hr": "hr",
  "shared_components.profile_form.company_name": "Company Name",
  "shared_components.profile_form.complete_profile": "Complete Profile",
  "shared_components.profile_form.first_name": "First Name",
  "shared_components.profile_form.friend_family": "Friend or family",
  "shared_components.profile_form.heard_about_us": "How did you hear about us?",
  "shared_components.profile_form.job_title": "Job Title",
  "shared_components.profile_form.last_name": "Last Name",
  "shared_components.profile_form.online_search": "Online search",
  "shared_components.profile_form.other": "Other",
  "shared_components.profile_form.peerspace_contacted": "Peerspace contacted me",
  "shared_components.profile_form.peerspace_location": "Was in a Peerspace location",
  "shared_components.profile_form.phone_number": "Phone Number",
  "shared_components.profile_form.radio_tv": "Radio or television",
  "shared_components.profile_form.select_option": "Select Option",
  "shared_components.profile_form.social_media": "Social media",
  "shared_components.profile_pic.upload_photo": "Upload Photo",
  "shared_components.profile_pic.upload_your_photo": "Upload Your Profile Photo",
  "shared_components.recipient_form.account_type_error": "Please select your account type",
  "shared_components.recipient_form.account_type_label": "Select Account Type",
  "shared_components.recipient_form.account_type_off_label": "Personal",
  "shared_components.recipient_form.account_type_on_label": "Business",
  "shared_components.recipient_form.business_input_placeholder": "Legal Business Name",
  "shared_components.recipient_form.business_more_info": "Your legal business name will be used to verify your company identity and must match what is on record when you submit your EIN.",
  "shared_components.recipient_form.button_update": "Update",
  "shared_components.recipient_form.name_input_placeholder": "Full Legal Name",
  "shared_components.recipient_form.name_label": "Name",
  "shared_components.recipient_form.name_more_info": "Your legal name will be used to verify your identity and must match what is on record when you submit your SSN.",
  "shared_components.recipient_form.organization_label": "Organization",
  "shared_components.recipient_form.payout_error": "Something went wrong. Please try again.",
  "shared_components.recipient_form.update_bank_account": "Update your bank account",
  "shared_components.recipient_form.update_bank_account_description": "Please enter your banking information to approve this booking. We’ll directly deposit all of your payouts into your account.",
  "shared_components.referral_banner.body": "Share your referral link to give a $50 discount to friends and followers. When they book their first space, you'll earn a $50 credit.",
  "shared_components.referral_banner.button_label": "Get referral link",
  "shared_components.referral_banner.header": "Give $50. Get $50.",
  "shared_components.response_time.in_over_": "in over {hours} hrs",
  "shared_components.response_time.within_1_hour": "within 1 hr",
  "shared_components.response_time.within_any_hours": "within {hours} hrs",
  "shared_components.responsiveness.new_space": "New space",
  "shared_components.responsiveness.text": "Responds {bucket_text}",
  "shared_components.review.error_review_empty": "Please fill in your response",
  "shared_components.review.error_review_long": "Your review must be less than 1500 characters long",
  "shared_components.review.error_review_short": "Your review must be more than 5 characters long",
  "shared_components.review_form.activity_did_you_do": "What activity did you do in the the space?",
  "shared_components.review_form.book_again": "Yes, I would book again",
  "shared_components.review_form.booking_go_planned": "Did the booking go as planned?",
  "shared_components.review_form.easy_work_with": "How easy were they to work with?",
  "shared_components.review_form.feedback_will_help": "Your feedback will help other {reviewType} know what to expect. Please describe your experience booking with {revieweeName}.",
  "shared_components.review_form.follow_host_rules": "Did they follow your host rules?",
  "shared_components.review_form.host_again": "Yes, I would host them again",
  "shared_components.review_form.leave_review_placeholder": "Leave a review",
  "shared_components.review_form.not_book_again": "No, I would not book again",
  "shared_components.review_form.not_host_again": "No, I would not host them again",
  "shared_components.review_form.responsive_was_host": "How responsive was the host?",
  "shared_components.review_form.review_form_button": "Submit Review",
  "shared_components.review_form.review_form_skip_button": "Snooze, I'll do this later",
  "shared_components.review_form.review_guest_name": "Before continuing, leave {guest} a review",
  "shared_components.review_form.review_pagination": "{currentReview} of {totalReviews} reviews",
  "shared_components.review_form.review_space": "Review this space",
  "shared_components.review_form.select_option": "Please select an option.",
  "shared_components.review_form.something_wrong": "Something went wrong. Please try again.",
  "shared_components.review_form.space_appear": "Did the space appear as advertised?",
  "shared_components.review_form.update_bank_account_description": "Your review will be kept private until {revieweeName} completes their review.",
  "shared_components.review_stars.leave_rating": "Please leave a rating",
  "shared_components.review_stars.rate": "Rate",
  "shared_components.search-form.search": "Search",
  "shared_components.search_date_time_button.default_label": "When?",
  "shared_components.signup_form.account_exists": "This account already exists, please",
  "shared_components.signup_form.account_exists_error": "with {loginType}.",
  "shared_components.signup_form.account_exists_login": "login",
  "shared_components.signup_form.already_have_account": "Already have an account?",
  "shared_components.signup_form.apple_error": "Something went wrong, please try again. If the problem persists please refresh.",
  "shared_components.signup_form.apple_signup": "Sign up with Apple",
  "shared_components.signup_form.email_opt_checkbox": "I don’t want to receive marketing emails from Peerspace.",
  "shared_components.signup_form.email_opt_message": "Peerspace will send you deals, inspiration, and marketing emails. You can opt out at any time from your account settings.",
  "shared_components.signup_form.email_take": "This email is already taken.",
  "shared_components.signup_form.error": "An unexpected error occurred. Please try again in a few minutes.",
  "shared_components.signup_form.facebook_error": "Your account was created with Facebook. Please use Facebook to log in.",
  "shared_components.signup_form.fb_signup": "Sign up with Facebook",
  "shared_components.signup_form.google_signup": "Sign up with Google",
  "shared_components.signup_form.login_link": "Login",
  "shared_components.signup_form.or": "or",
  "shared_components.signup_form.refresh_error": "Something went wrong, please try again. If the problem persists please refresh.",
  "shared_components.signup_form.reset_password_link": "reset your password",
  "shared_components.signup_form.signup": "Sign Up",
  "shared_components.signup_manager.code_sent": "Code Sent!",
  "shared_components.signup_manager.host_guest_form_header": "Welcome!",
  "shared_components.signup_manager.host_guest_form_subheader": "What would you like to do?",
  "shared_components.signup_manager.login_different_account": "Login with a different account",
  "shared_components.signup_manager.profile_form_header": "Complete your profile",
  "shared_components.signup_manager.profile_form_subheader": "This helps build trust between guests and hosts.",
  "shared_components.signup_manager.verification_form_header": "Verify your email",
  "shared_components.signup_manager.verification_form_subheader": "Please check your email and enter the 4-digit code below.",
  "shared_components.signup_manager.welcome_back_form_header": "Welcome back",
  "shared_components.signup_manager.welcome_back_form_subheader": "You already have an account using Facebook, please log in.",
  "shared_components.social_email_form.already_taken_error": "This email is already taken. Please {link} instead.",
  "shared_components.social_email_form.checkbox_label": "I don’t want to receive marketing emails from Peerspace.",
  "shared_components.social_email_form.cta_label": "Continue",
  "shared_components.social_email_form.cta_text": "Peerspace will send you deals, inspiration, and marketing emails. You can opt out at any time from your account settings.",
  "shared_components.social_email_form.expired_error": "Your sign up session has expired. Click the X to start over.",
  "shared_components.social_email_form.header": "What's the best email for you?",
  "shared_components.social_email_form.invalid_error": "An unexpected error occurred. Please try again in a few minutes.",
  "shared_components.social_email_form.login": "log in",
  "shared_components.social_email_form.text": "We’ll send all your bookings and messages here, so make sure it’s the one you check regularly.",
  "shared_components.tax_id_form.add_tax_id": "Add Your Tax ID",
  "shared_components.tax_id_form.add_tax_id_description": "Please enter your tax ID for your account below. This information is for identity verification required for payouts and tax compliance.",
  "shared_components.tax_id_form.button_update": "Update",
  "shared_components.tax_id_form.error_message": "An unexpected error occured. Please try again in a few minutes.",
  "shared_components.tax_id_form.identification_number_label": "Employer Identification Number (EIN)",
  "shared_components.tax_id_form.not_store_banking_data": "We do not store your banking data. We pass it securely to our payments partner.",
  "shared_components.tax_id_form.payout_account": "Your payout account",
  "shared_components.tax_id_form.security_number_label": "Social Security Number",
  "shared_components.toggle.select_option": "Please select an option.",
  "shared_components.transactable_main.banner_following": "Before you can move forward, please complete the following.",
  "shared_components.transactable_main.banner_skip_limit_reached": "This review has reached its snooze limit. Please complete or {contact}.",
  "shared_components.transactable_main.thank_you": "Thank you",
  "shared_components.transactable_main.transition_view_done": "Done",
  "shared_components.transactable_main.transition_view_next": "Next",
  "shared_components.transactable_main.transition_view_submitted": "Your {actionType} was successfully submitted!",
  "shared_components.verification_form.invalid_code_error": "Please enter a valid 4-digit code.",
  "shared_components.verify_email.add_valid_code": "Please add a valid code",
  "shared_components.verify_email.check_email": "Please check your email and enter the 4-digit code below to make sure your account is valid.",
  "shared_components.verify_email.check_email_button": "Verify",
  "shared_components.verify_email.contact_us": "or contact our support team",
  "shared_components.verify_email.didnt_get_email": "Didn’t get an email? It can take a few minutes, but also check your Spam and Promotions folder.",
  "shared_components.verify_email.help_peerspace": "Hi Peerspace, can you help me verify my email address. My user ID is {ssoId}. Thanks! {firstName}",
  "shared_components.verify_email.resend_code": "Resend code",
  "shared_components.verify_email.verify_email": "Verify Your Email",
  "shared_components.view_listing_link.text": "View Space",
  "signin.login_manager.facebook_account_exists": "This account already exists, please login with email.",
  "signin.login_manager.google_account_exists": "This account already exists, please login with email.",
  "stripe_payment_error.account_already_exists": "The email address provided for the creation of a deferred account already has an account associated with it. Use the OAuth flow to connect the existing account to your platform.",
  "stripe_payment_error.account_country_invalid_address": "The country of the business address provided does not match the country of the account. Businesses must be located in the same country as the account.",
  "stripe_payment_error.account_invalid": "The account ID provided as a value for the Stripe-Account header is invalid. Check that your requests are specifying a valid account ID.",
  "stripe_payment_error.account_number_invalid": "The bank account number provided is invalid (e.g., missing digits). Bank account information varies from country to country. We recommend creating validations in your entry forms based on the bank account formats we provide.",
  "stripe_payment_error.alipay_upgrade_required": "This method for creating Alipay payments is not supported anymore. Please upgrade your integration to use Sources instead.",
  "stripe_payment_error.amount_too_large": "The specified amount is greater than the maximum amount allowed. Use a lower amount and try again.",
  "stripe_payment_error.amount_too_small": "The specified amount is less than the minimum amount allowed. Use a higher amount and try again.",
  "stripe_payment_error.api_key_expired": "The API key provided has expired. Obtain your current API keys from the Dashboard and update your integration to use them.",
  "stripe_payment_error.balance_insufficient": "The transfer or payout could not be completed because the associated account does not have a sufficient balance available. Create a new transfer or payout using an amount less than or equal to the account’s available balance.",
  "stripe_payment_error.bank_account_exists": "The bank account provided already exists on the specified Customer object. If the bank account should also be attached to a different customer, include the correct customer ID when making the request again.",
  "stripe_payment_error.bank_account_unusable": "The bank account provided cannot be used for payouts. A different bank account must be used.",
  "stripe_payment_error.bank_account_unverified": "Your Connect platform is attempting to share an unverified bank account with a connected account.",
  "stripe_payment_error.bitcoin_upgrade_required": "This method for creating Bitcoin payments is not supported anymore. Please upgrade your integration to use Sources instead.",
  "stripe_payment_error.card_declined": "The card has been declined. When a card is declined, the error returned also includes the decline_code attribute with the reason why the card was declined. Refer to our decline codes documentation to learn more.",
  "stripe_payment_error.charge_already_captured": "The charge you’re attempting to capture has already been captured. Update the request with an uncaptured charge ID.",
  "stripe_payment_error.charge_already_refunded": "The charge you’re attempting to refund has already been refunded. Update the request to use the ID of a charge that has not been refunded.",
  "stripe_payment_error.charge_disputed": "The charge you’re attempting to refund has been charged back. Check the disputes documentation to learn how to respond to the dispute.",
  "stripe_payment_error.charge_exceeds_source_limit": "This charge would cause you to exceed your rolling-window processing limit for this source type. Please retry the charge later, or contact us to request a higher processing limit.",
  "stripe_payment_error.charge_expired_for_capture": "The charge cannot be captured as the authorization has expired. Auth and capture charges must be captured within seven days.",
  "stripe_payment_error.country_unsupported": "Your platform attempted to create a custom account in a country that is not yet supported. Make sure that users can only sign up in countries supported by custom accounts.",
  "stripe_payment_error.coupon_expired": "The coupon provided for a subscription or order has expired. Either create a new coupon, or use an existing one that is valid.",
  "stripe_payment_error.customer_max_subscriptions": "The maximum number of subscriptions for a customer has been reached. Contact us if you are receiving this error.",
  "stripe_payment_error.email_invalid": "The email address is invalid (e.g., not properly formatted). Check that the email address is properly formatted and only includes allowed characters.",
  "stripe_payment_error.expired_card": "The card has expired. Check the expiration date or use a different card.",
  "stripe_payment_error.generic_decline": "The card was declined for an unknown reason or possibly triggered by a blocked payment rule.",
  "stripe_payment_error.idempotency_key_in_use": "The idempotency key provided is currently being used in another request. This occurs if your integration is making duplicate requests simultaneously.",
  "stripe_payment_error.incorrect_address": "The card’s address is incorrect. Check the card’s address or use a different card.",
  "stripe_payment_error.incorrect_cvc": "The card’s security code is incorrect. Check the card’s security code or use a different card.",
  "stripe_payment_error.incorrect_number": "The card number is incorrect. Check the card’s number or use a different card.",
  "stripe_payment_error.incorrect_zip": "The card’s postal code is incorrect. Check the card’s postal code or use a different card.",
  "stripe_payment_error.instant_payouts_unsupported": "The debit card provided as an external account does not support instant payouts. Provide another debit card or use a bank account instead.",
  "stripe_payment_error.insufficient_funds": "The card has insufficient funds to complete the purchase.",
  "stripe_payment_error.invalid_card_type": "The card provided as an external account is not a debit card. Provide a debit card or use a bank account instead.",
  "stripe_payment_error.invalid_charge_amount": "The specified amount is invalid. The charge amount must be a positive integer in the smallest currency unit, and not exceed the minimum or maximum amount.",
  "stripe_payment_error.invalid_cvc": "The card’s security code is invalid. Check the card’s security code or use a different card.",
  "stripe_payment_error.invalid_expiry_month": "The card’s expiration month is incorrect. Check the expiration date or use a different card.",
  "stripe_payment_error.invalid_expiry_year": "The card’s expiration year is incorrect. Check the expiration date or use a different card.",
  "stripe_payment_error.invalid_number": "The card number is invalid. Check the card details or use a different card.",
  "stripe_payment_error.invalid_source_usage": "The source cannot be used because it is not in the correct state (e.g., a charge request is trying to use a source with a pending, failed, or consumed source). Check the status of the source you are attempting to use.",
  "stripe_payment_error.invoice_no_customer_line_items": "An invoice cannot be generated for the specified customer as there are no pending invoice items. Check that the correct customer is being specified or create any necessary invoice items first.",
  "stripe_payment_error.invoice_no_subscription_line_items": "An invoice cannot be generated for the specified subscription as there are no pending invoice items. Check that the correct subscription is being specified or create any necessary invoice items first.",
  "stripe_payment_error.invoice_not_editable": "The specified invoice can no longer be edited. Instead, consider creating additional invoice items that will be applied to the next invoice. You can either manually generate the next invoice or wait for it to be automatically generated at the end of the billing cycle.",
  "stripe_payment_error.invoice_upcoming_none": "There is no upcoming invoice on the specified customer to preview. Only customers with active subscriptions or pending invoice items have invoices that can be previewed.",
  "stripe_payment_error.livemode_mismatch": "Test and live mode API keys, requests, and objects are only available within the mode they are in.",
  "stripe_payment_error.lost_card": "The payment was declined because the card is reported lost.",
  "stripe_payment_error.missing": "Both a customer and source ID have been provided, but the source has not been saved to the customer. To create a charge for a customer with a specified source, you must first save the card details.",
  "stripe_payment_error.not_allowed_on_standard_account": "Transfers and payouts on behalf of a Standard connected account are not allowed.",
  "stripe_payment_error.order_creation_failed": "The order could not be created. Check the order details and then try again.",
  "stripe_payment_error.order_required_settings": "The order could not be processed as it is missing required information. Check the information provided and try again.",
  "stripe_payment_error.order_status_invalid": "The order cannot be updated because the status provided is either invalid or does not follow the order lifecycle (e.g., an order cannot transition from created to fulfilled without first transitioning to paid).",
  "stripe_payment_error.order_upstream_timeout": "The request timed out. Try again later.",
  "stripe_payment_error.out_of_inventory": "The SKU is out of stock. If more stock is available, update the SKU’s inventory quantity and try again.",
  "stripe_payment_error.parameter_invalid_empty": "One or more required values were not provided. Make sure requests include all required parameters.",
  "stripe_payment_error.parameter_invalid_integer": "One or more of the parameters requires an integer, but the values provided were a different type. Make sure that only supported values are provided for each attribute. Refer to our API documentation to look up the type of data each attribute supports.",
  "stripe_payment_error.parameter_invalid_string_blank": "One or more values provided only included whitespace. Check the values in your request and update any that contain only whitespace.",
  "stripe_payment_error.parameter_invalid_string_empty": "One or more required string values is empty. Make sure that string values contain at least one character.",
  "stripe_payment_error.parameter_missing": "One or more required values are missing. Check our API documentation to see which values are required to create or modify the specified resource.",
  "stripe_payment_error.parameter_unknown": "The request contains one or more unexpected parameters. Remove these and try again.",
  "stripe_payment_error.parameters_exclusive": "Two or more mutually exclusive parameters were provided. Check our API documentation or the returned error message to see which values are permitted when creating or modifying the specified resource.",
  "stripe_payment_error.payment_intent_authentication_failure": "The provided source has failed authentication. Provide source_data or a new source to attempt to fulfill this PaymentIntent again.",
  "stripe_payment_error.payment_intent_incompatible_payment_method": "The PaymentIntent expected a payment method with different properties than what was provided.",
  "stripe_payment_error.payment_intent_invalid_parameter": "One or more provided parameters was not allowed for the given operation on the PaymentIntent. Check our API reference or the returned error message to see which values were not correct for that PaymentIntent.",
  "stripe_payment_error.payment_intent_payment_attempt_failed": "The latest payment attempt for the PaymentIntent has failed. Check the last_payment_error property on the PaymentIntent for more details, and provide source_data or a new source to attempt to fulfill this PaymentIntent again.",
  "stripe_payment_error.payment_intent_unexpected_state": "The PaymentIntent’s state was incompatible with the operation you were trying to perform.",
  "stripe_payment_error.payment_method_unactivated": "The charge cannot be created as the payment method used has not been activated. Activate the payment method in the Dashboard, then try again.",
  "stripe_payment_error.payment_method_unexpected_state": "The provided payment method’s state was incompatible with the operation you were trying to perform. Confirm that the payment method is in an allowed state for the given operation before attempting to perform it.",
  "stripe_payment_error.payouts_not_allowed": "Payouts have been disabled on the connected account. Check the connected account’s status to see if any additional information needs to be provided, or if payouts have been disabled for another reason.",
  "stripe_payment_error.platform_api_key_expired": "The API key provided by your Connect platform has expired. This occurs if your platform has either generated a new key or the connected account has been disconnected from the platform. Obtain your current API keys from the Dashboard and update your integration, or reach out to the user and reconnect the account.",
  "stripe_payment_error.postal_code_invalid": "The postal code provided was incorrect.",
  "stripe_payment_error.processing_error": "An error occurred while processing the card. Check the card details are correct or use a different card.",
  "stripe_payment_error.product_inactive": "The product this SKU belongs to is no longer available for purchase.",
  "stripe_payment_error.rate_limit": "Too many requests hit the API too quickly. We recommend an exponential backoff of your requests.",
  "stripe_payment_error.resource_already_exists": "A resource with a user-specified ID (e.g., plan or coupon) already exists. Use a different, unique value for id and try again.",
  "stripe_payment_error.resource_missing": "The ID provided is not valid. Either the resource does not exist, or an ID for a different resource has been provided.",
  "stripe_payment_error.routing_number_invalid": "The bank routing number provided is invalid.",
  "stripe_payment_error.secret_key_required": "The API key provided is a publishable key, but a secret key is required. Obtain your current API keys from the Dashboard and update your integration to use them.",
  "stripe_payment_error.sepa_unsupported_account": "Your account does not support SEPA payments.",
  "stripe_payment_error.shipping_calculation_failed": "Shipping calculation failed as the information provided was either incorrect or could not be verified.",
  "stripe_payment_error.sku_inactive": "The SKU is inactive and no longer available for purchase. Use a different SKU, or make the current SKU active again.",
  "stripe_payment_error.state_unsupported": "Occurs when providing the legal_entity information for a U.S. custom account, if the provided state is not supported. (This is mostly associated states and territories.)",
  "stripe_payment_error.stolen_card": "The payment was declined because the card is reported stolen.",
  "stripe_payment_error.tax_id_invalid": "The tax ID number provided is invalid (e.g., missing digits). Tax ID information varies from country to country, but must be at least nine digits.",
  "stripe_payment_error.taxes_calculation_failed": "Tax calculation for the order failed.",
  "stripe_payment_error.testmode_charges_only": "Your account has not been activated and can only make test charges. Activate your account in the Dashboard to begin processing live charges.",
  "stripe_payment_error.tls_version_unsupported": "Your integration is using an older version of TLS that is unsupported. You must be using TLS 1.2 or above.",
  "stripe_payment_error.token_already_used": "The token provided has already been used. You must create a new token before you can retry this request.",
  "stripe_payment_error.token_in_use": "The token provided is currently being used in another request. This occurs if your integration is making duplicate requests simultaneously.",
  "stripe_payment_error.transfers_not_allowed": "The requested transfer cannot be created. Contact us if you are receiving this error.",
  "stripe_payment_error.upstream_order_creation_failed": "The order could not be created. Check the order details and then try again.",
  "stripe_payment_error.url_invalid": "The URL provided is invalid.",
  "sy+pv5": "Email",
  "t4hwZA": "Aborted",
  "tYR8j7": "Garage",
  "toast-text": "Error, please check changes",
  "tv5FG3": "Blog",
  "tvx81x": "Castle",
  "txUL0F": "Last name",
  "tyF1wo": "Select option",
  "u3FOfl": "Newtown",
  "uCk8r+": "Already have an account?",
  "uFwMw7": "File is too large",
  "ug/vzI": "Earn $50",
  "uhtUXn": "2 character minimum",
  "uizmax": "Press",
  "uwVj77": "Kitchen",
  "uxvKKF": "Bookings",
  "v5oVYO": "Community Center",
  "vVp/Gg": "Online search",
  "vmNLEI": "Bridal shower ideas",
  "vx0nkZ": "Privacy Policy",
  "vz5CAF": "Photo Shoot",
  "w6J38y": "Upload more",
  "wCnsqP": "Bagnolet",
  "wEQDC6": "Edit",
  "wFpDkm": "Fire Pit",
  "wW7xBB": "Drag handle to resize",
  "wXmCDt": "Manchester",
  "wYcYcy": "Melbourne",
  "web-seo-v2.footer.log_out": "Log out",
  "web-seo-v2.footer.sign_up": "Sign Up",
  "web-seo-v2.nav.account": "Payments",
  "web-seo-v2.nav.add_ons": "Add-ons",
  "web-seo-v2.nav.add_payout_info": "Add payout info",
  "web-seo-v2.nav.boards": "Boards",
  "web-seo-v2.nav.bookings": "Bookings",
  "web-seo-v2.nav.browse_spaces": "Browse Spaces",
  "web-seo-v2.nav.calendar": "Calendar",
  "web-seo-v2.nav.community": "Community",
  "web-seo-v2.nav.current": "(current)",
  "web-seo-v2.nav.help": "Help",
  "web-seo-v2.nav.inbox": "Inbox",
  "web-seo-v2.nav.list_your_space": "List Your Space",
  "web-seo-v2.nav.listings": "Listings",
  "web-seo-v2.nav.log_in": "Log In",
  "web-seo-v2.nav.payments": "Payments",
  "web-seo-v2.nav.payouts_blocked": "Payouts blocked",
  "web-seo-v2.nav.profile": "Profile",
  "web-seo-v2.nav.referrals": "Earn ${count}",
  "web-seo-v2.nav.review": "Reviews",
  "web-seo-v2.nav.search": "Search",
  "wmi6TT": "Meeting",
  "x2QnyM": "Enter the 4-digit code we sent to {phone_number} below. If you didn’t get it, {resend}",
  "x3qVIr": "Ideas",
  "xWGWJp": "How did you hear about us?",
  "xkr+zo": "Terms",
  "xmcVZ0": "Search",
  "y4bJBC": "Peerspace will send you deals, inspiration, and marketing emails. You can opt out anytime in your account settings. {boldText}",
  "yF/QJ9": "Peerspace footer logo",
  "yJ1ORH": "Careers",
  "yOQXwq": "Radio or television",
  "yoLwRW": "See more",
  "z6QqQm": "Experiences",
  "zKcR07": "File format not allowed",
  "zPxgYg": "Did you know Saturdays are the most booked days for events? Please take a moment to confirm your availability or update your calendar."
}